import loadable from '@loadable/component';

// 懒加载组件
const InvoiceManagement2308 = loadable(() => import('./invoiceManagement2308/InvoiceManagement'));

export const subRoutes = [
  {
    // M258008 【2308】供应商：供应商发票管理
    path: '/InvoiceManagement2308',
    component: InvoiceManagement2308
  }
];
